/**
 * @file area.service.js
 * @module AreaService
 * @description Reads the coverage area data the experience product form needs.
 */

import { AreasAPI } from "../../../../../core/api";

/**
 * Fetches the polygon of a coverage area.
 * @param {string} areaId
 * @param {string} token
 * @returns {Promise<Array<{ lat: number, lng: number }>|null>} The polygon, or
 * null when it could not be loaded.
 */
export const fetchAreaPolygon = async (areaId, token) => {
  try {
    const { data } = await AreasAPI.getAreaById(areaId, token);
    return data.status ? data.data.polygon || [] : null;
  } catch (error) {
    return null;
  }
};
